/**
 * 头部导航项样式组件
 */
import Item from './Item.vue';

export default Item;